import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';

export const MAP_OUTSIDE_DESTINATION_HOTELS_RETRIEVED = 'MAP_OUTSIDE_DESTINATION_HOTELS_RETRIEVED';
export const MAP_OUTSIDE_DESTINATION_HOTELS_RETRIEVED_VERSION = '1.0';

export type MapOutsideDestinationHotelsRetrievedPayload = {
  searchId: string;
  destination: string;
};

type GetOutsideDestinationsProps = {
  productsData: ProductsData;
};
export const getOutsideDestinations = ({ productsData }: GetOutsideDestinationsProps): string[] =>
  (productsData.dealCards || []).reduce(
    (result: string[], dealCard) =>
      !dealCard.product.rate.flags.fallback &&
      !dealCard.product.rate.flags.livectx &&
      !result.includes(`${dealCard.product.geo.internalIdCity}`)
        ? result.concat(`${dealCard.product.geo.internalIdCity}`)
        : result,
    []
  );

type HasOutsideDestinationsProps = {
  productsData: ProductsData;
};
export const hasOutsideDestinations = ({ productsData }: HasOutsideDestinationsProps): boolean =>
  getOutsideDestinations({ productsData }).length > 0;

export type MapOutsideDestinationHotelsRetrievedParams = {
  searchParams: SearchParams;
  productsData: ProductsData;
};
export const createMapOutsideDestinationHotelsRetrievedPayload = ({
  searchParams,
  productsData,
}: MapOutsideDestinationHotelsRetrievedParams): MapOutsideDestinationHotelsRetrievedPayload => {
  const searchId = searchParams[URLParameters.SEARCH_ID] || '';
  const destination = getOutsideDestinations({ productsData }).join(',');

  return {
    searchId,
    destination,
  };
};
